import { fromBase64, toBase64 } from '../utils/base64.js';
const inMemoryStorage = new Map();
/**
 * Reads value from storage and decrypts the base64 string before returning
 */
export function getItem(itemName) {
    if (typeof window === 'undefined')
        return null;
    try {
        const persistedData = window.localStorage.getItem(itemName);
        // base64 decode value from storage
        return persistedData ? fromBase64(persistedData) : null;
    }
    catch {
        return inMemoryStorage.get(itemName) ?? null;
    }
}
/**
 * Sets and Updates the storage value using base64 encryption
 */
export function setItem(itemToSave, itemValue) {
    if (typeof window === 'undefined')
        return;
    try {
        // base64 encode before saving in storage
        const base64Str = toBase64(itemValue);
        window.localStorage.setItem(itemToSave, base64Str);
    }
    catch (e) {
        inMemoryStorage.set(itemToSave, itemValue);
    }
}
/**
 * Removes the storage value.
 */
export function removeItem(itemName) {
    if (typeof window === 'undefined')
        return;
    try {
        window.localStorage.removeItem(itemName);
    }
    catch {
        inMemoryStorage.delete(itemName);
    }
}
export default { getItem, setItem, removeItem };
//# sourceMappingURL=localStorage.js.map